import { useState, useEffect } from 'react';
import qs from 'qs';
import { useNavigate } from 'react-router-dom';
import { Grid, TextInput, Button } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { IconSearch } from '@tabler/icons-react';

import * as imovelActions from '../../../actions/Lote';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { useOptionalNavegadorMap } from '../../../components/Navegador/NavegadorMapContext';

interface FindProps {
  autoFocus?: boolean;
}

export default function Find({ autoFocus = false }: FindProps) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const loading = useAppSelector((state) => state.container.loading);
  const inShell = !!useOptionalNavegadorMap();

  const [filterText, setFilterText] = useState('');
  const [placeHolder, setPlaceHolder] = useState('');

  useEffect(() => {
    dispatch((imovelActions as any).getPlaceHolderByModule((x: { data: string }) => {
      setPlaceHolder(x.data);
    }));
  }, [dispatch]);

  const clickSearch = () => {
    if (!filterText || filterText.trim().length === 0) {
      navigate('/navegador-geofinanceiro');
      notifications.show({ message: 'É necessário informar um valor para busca.', color: 'yellow' });
      dispatch((imovelActions as any).clearList());
      return;
    }

    const query = qs.stringify({ page: 1, q: filterText });
    navigate(`/navegador-geofinanceiro?${query}`);
  };

  return (
    <Grid>
      <Grid.Col span={{ base: 12, md: inShell ? 12 : 7 }} offset={{ base: 0, md: inShell ? 0 : 2 }}>
        <TextInput
          disabled={loading}
          autoFocus={autoFocus}
          maxLength={300}
          placeholder={placeHolder}
          leftSection={<IconSearch size={16} />}
          value={filterText || ''}
          onChange={(e) => setFilterText(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') clickSearch(); }}
          rightSectionWidth={92}
          rightSection={
            <Button size="xs" onClick={clickSearch} leftSection={<IconSearch size={14} />}>
              Buscar
            </Button>
          }
        />
      </Grid.Col>
    </Grid>
  );
}
